import { Injectable } from '@angular/core';
import { FrappeApp, FrappeCall, FrappeDB } from 'frappe-js-sdk';
import { AppConstant } from '../app.constant';

@Injectable({
    providedIn: 'root'
})
export class PaymentService {
    private frappe: FrappeApp;
    private frappeCall: FrappeCall;
    private db:FrappeDB;
    constructor() {
        this.frappe = new FrappeApp(AppConstant.frappeUrl);
        this.frappeCall = this.frappe.call()
        this.db=this.frappe.db()
    }

    public get_payment_list(): Promise<any> {
        return this.frappe.call().get('vendor_portal.rest.get_payment');
    }

    public getPaymentLists(data:any): Promise<any> {
        return this.frappeCall.get('vendor_portal.rest.get_pageable_payment',{ data })
    }
    
}
